import * as React from 'react';
import { Box, Container, CssBaseline, Divider, IconButton, Snackbar, Alert, Collapse
  , List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography, Tooltip, Hidden } from "@mui/material";
import MuiDrawer from '@mui/material/Drawer';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import { Menu as MenuIcon, Inbox as InboxIcon, Person as PersonIcon, RecordVoiceOver as RecordVoiceOverIcon
  , EmojiPeople as EmojiPeopleIcon, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon
  , CalendarMonth as CalendarMonthIcon, AssignmentInd as AssignmentIndIcon, EscalatorWarning as EscalatorWarningIcon
  , ContentPasteSearch as ContentPasteSearchIcon, Badge as BadgeIcon, AddCard as AddCardIcon, NoteAlt as NoteAltIcon
  , Calculate as CalculateIcon, BarChart as BarChartIcon, List as ListIcon
  , Logout as LogoutIcon, Block as BlockIcon, DoneAll as DoneAllIcon
  , ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon
  , Settings as SettingsIcon, School as SchoolIcon, Timeline as TimelineIcon, MonitorHeart as MonitorHeartIcon
  , MedicalServices as MedicalServicesIcon, Security as SecurityIcon } from "@mui/icons-material";

import useMediaQuery from "@mui/material/useMediaQuery";

import { BrowserRouter as Router, Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { registerShowMessage } from "./services/notificationService";
import { cerrarSesion, obtenerUsuario } from "./services/authService";
import { useDispatch, useSelector } from 'react-redux';
import { setAccesos, setParametros, setPerfil, limpiarSeguridad } from "./redux/seguridadSlice";
import * as seguridadService from "./services/seguridadService";
import RutaProtegida from "./components/RutaProtegida";
import RutaConAcceso from "./components/RutaConAcceso";
import PerfilUsuario from "./components/PerfilUsuario";
import { navGroups, visiblesDe } from "./menu";
import Login from "./containers/Login/Index";
import Dashboard from "./containers/Dashboard/Index";
import Person from "./containers/Person/Index";
import Model from "./containers/Model/Index";
import PersonEdit from "./containers/Person/Edit";
import PersonEditLegal from "./containers/Person/EditLegal.js";
import Member from "./containers/Member/Index";
import MemberEdit from "./containers/Member/Edit";
import Therapy from './containers/Therapy/Index';
import TherapyEdit from './containers/Therapy/Edit';
import TherapyPlan from './containers/TherapyPlan/Index';
import TherapyPlanTherapist from './containers/TherapyPlanTherapist/Index';
import TherapyPlanTherapistEdit from './containers/TherapyPlanTherapist/Edit';
import TherapyPlanEdit from './containers/TherapyPlan/Edit';
import TherapyPeriod from './containers/TherapyPeriod/Index';
import Period from './containers/Period/Index';
import PeriodEdit from './containers/Period/Edit';
import Filial from './containers/Filial/Index';
import FilialEdit from './containers/Filial/Edit';
import Puntuacion from './containers/Puntuacion/Index';
import PuntuacionEdit from './containers/Puntuacion/Edit';
import Configuracion from './containers/Configuracion/Index';
import ConfiguracionEdit from './containers/Configuracion/Edit';
import Bitacora from './containers/Bitacora/Index';
import BitacoraReportes from './containers/Bitacora/Reportes';
import OperacionesBitacora from './containers/Bitacora/Operaciones';
import Monitoreo from './containers/Monitoreo/Index';
import Evaluacion from './containers/Evaluacion/Index';
import EvaluacionEdit from './containers/Evaluacion/Edit';
import EvaluacionTema from './containers/Evaluacion/TemaIndex';
import EvaluacionTemaEdit from './containers/Evaluacion/TemaEdit';
import ObjetivoCatalogo from './containers/ObjetivoCatalogo/Index';
import ObjetivoCatalogoEdit from './containers/ObjetivoCatalogo/Edit';
import ParticipanteObjetivo from './containers/ParticipanteObjetivo/Index';
import ParticipanteObjetivoEdit from './containers/ParticipanteObjetivo/Edit';
import TherapyPeriodOpen from './containers/TherapyPeriod/Open';
import TherapyPeriodPayment from './containers/TherapyPeriod/Payment';
import TherapyPeriodPaymentEdit from './containers/TherapyPeriod/PaymentEdit';
import TherapyPeriodDescuentos from './containers/TherapyPeriod/Descuentos';
import DiaFeriado from './containers/DiaFeriado/Index';
import Atencion from './containers/Atencion/Index';
import AtencionEdit from './containers/Atencion/Edit';
import Diagnostico from './containers/Diagnostico/Index';
import DiagnosticoEdit from './containers/Diagnostico/Edit';
import SecurityUser from './containers/Security/User';
import SecurityUserEdit from './containers/Security/UserEdit';
import SecurityRole from './containers/Security/Role';
import SecurityRoleEdit from './containers/Security/RoleEdit';
import SecurityAccess from './containers/Security/Access';
import Authorization from './containers/Authorization/Index';
import SessionTherapist from './containers/Session/IndexTherapist';
import SessionEdit from './containers/Session/Edit';
import Session from './containers/Session/Index';
import SesionTerapeuta from './containers/SesionTerapeuta/Index';
import Planilla from './containers/Planilla/Index';
import ReporteModelo from './containers/Reporte/Modelos';
import ReporteIndex from './containers/Reporte/Index';
import ReporteTerapia from './containers/Reporte/Terapias';
import ReporteSesion from './containers/Reporte/Sesiones';
import ReportePlanTerapia from './containers/Reporte/PlanTerapia';
import ReporteTrimestral from './containers/Reporte/Trimestral';
import ReporteFichaParticipante from './containers/Reporte/FichaParticipante';
import ReporteCurvaEficacia from './containers/Reporte/CurvaEficacia';
import ArticuloIndex from './containers/Inventario/ArticuloIndex';
import KardexIndex from './containers/Inventario/KardexIndex';
import ReporteKardex from './containers/Inventario/ReporteKardex';
import CajaChicaIndex from './containers/CajaChica/CajaChicaIndex';
import ReporteCajaChica from './containers/CajaChica/ReporteCajaChica';
import SalonIndex from './containers/Salon/Index';
import DireccionIndex from './containers/Direccion/Index';
import UbigeoIndex from './containers/Ubigeo/Index';
import useWindowSize from './components/useWindowSize';
import InvoiceItem from './containers/InvoiceItem/Index';
import DescuentoCatalogo from './containers/DescuentoCatalogo/Index';
import DescuentoCatalogoEdit from './containers/DescuentoCatalogo/Edit';
import InvoiceItemEdit from './containers/InvoiceItem/Edit';
import Receipt from './containers/Receipt/Index';
import ReceiptEdit from './containers/Receipt/Edit';
import ReceiptPayment from './containers/Receipt/Payment';
import ReceiptAnularPago from './containers/Receipt/AnularPago';
import ReceiptConsolidarPagos from './containers/Receipt/ConsolidarPagos';
import ReceiptPrint from './containers/Receipt/Print';
import Catalog from './containers/Catalog/Index';
import CatalogEdit from './containers/Catalog/Edit';
import Trabajador from './containers/Trabajador/Index';
import TrabajadorEdit from './containers/Trabajador/Edit';
import Cargo from './containers/Cargo/Index';
import CargoEdit from './containers/Cargo/Edit';
import GrupoCargo from './containers/GrupoCargo/Index';
import GrupoCargoEdit from './containers/GrupoCargo/Edit';
import HorarioTerapeuta from './containers/HorarioTerapeuta/Index';

const drawerOpenWidth = 240;
const drawerClosedWidth = 64;

const openedMixin = (theme) => ({
  width: drawerOpenWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 3,
  // zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // ...(open && {
  //   marginLeft: drawerWidth,
  //   width: `calc(100% - ${drawerWidth}px)`,
  //   transition: theme.transitions.create(['width', 'margin'], {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  // }),
}));

// const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
//   ({ theme, open }) => ({
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: 'nowrap',
//     boxSizing: 'border-box',
//     ...(open && {
//       ...openedMixin(theme),
//       '& .MuiDrawer-paper': openedMixin(theme),
//     }),
//     ...(!open && {
//       ...closedMixin(theme),
//       '& .MuiDrawer-paper': closedMixin(theme),
//     }),
//   }),
// );

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "expanded",
})(({ theme, expanded }) => ({
  width: expanded ? drawerOpenWidth : drawerClosedWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  position: "fixed",
  zIndex: theme.zIndex.drawer,

  "& .MuiDrawer-paper": {
    position: "fixed",
    width: expanded ? drawerOpenWidth : drawerClosedWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: expanded
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
    zIndex: theme.zIndex.drawer,
  },
}));


  // El menu lateral: navGroups y visiblesDe viven en menu.js, porque el inicio
// muestra las mismas opciones.

// Una opcion del menu: si tiene hijos es un grupo que despliega, y si no,
// navega. Es recursiva, asi que un grupo puede colgar de otro grupo: los
// reportes van en su subgrupo dentro de cada grupo.
//
// Vive fuera de Layout a proposito: si se definiera dentro, React lo trataria
// como un tipo distinto en cada render, desmontaria y remontaria todo el menu, y
// se perderian el foco del teclado y la posicion del desplazamiento.
const ItemMenu = ({ item, rama, menuAncho, gruposAbiertos, toggleGrupo, rutaActual, onNavegar, abrirMenu }) => {
  const clave = rama.join(" > ");
  const desplegado = gruposAbiertos[clave] === true;
  // Los grupos raiz van con su icono; lo de dentro se sangra segun el nivel,
  // para que las opciones de un grupo queden todas en la misma linea.
  const indentado = 3 + (rama.length - 1) * 3;
  const esRaiz = rama.length === 1;

  if (!item.children) {
    return (
      <ListItem disablePadding sx={{ display: "block" }} style={{ color: "black" }}>
        <ListItemButton
          component={Link}
          to={item.path}
          data-menu-ruta={item.path}
          selected={rutaActual === item.path}
          onClick={onNavegar}
          sx={{
            minHeight: esRaiz ? 48 : 38,
            justifyContent: esRaiz ? (menuAncho ? "initial" : "center") : "flex-start",
            px: esRaiz ? 2.5 : 0,
            pl: esRaiz ? (menuAncho ? 2.5 : 0) : indentado,
          }}
        >
          {rama.length === 1 && (
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: menuAncho ? 3 : 0,
                justifyContent: "center",
              }}
            >
              {item.icon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={item.title}
            primaryTypographyProps={rama.length === 1 ? {} : { fontSize: 14 }}
            sx={{
              opacity: menuAncho ? 1 : 0,
              display: menuAncho ? "block" : "none",
              whiteSpace: "nowrap"
            }}
          />
        </ListItemButton>
      </ListItem>
    );
  }

  // Grupo: el encabezado despliega sus opciones. Los subgrupos (los que
  // cuelgan de otro grupo) se sangran como el resto de las opciones.
  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <ListItemButton
        data-menu-grupo={clave}
        data-menu-abierto={desplegado ? "1" : "0"}
        onClick={() => toggleGrupo(clave, menuAncho, abrirMenu)}
        sx={{
          minHeight: esRaiz ? 48 : 38,
          justifyContent: esRaiz ? (menuAncho ? "initial" : "center") : "flex-start",
          px: esRaiz ? 2.5 : 0,
          pl: esRaiz ? (menuAncho ? 2.5 : 0) : indentado,
        }}
      >
        {esRaiz && (
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: menuAncho ? 3 : 0,
              justifyContent: "center",
            }}
          >
            {item.icon}
          </ListItemIcon>
        )}
        <ListItemText
          primary={item.title}
          primaryTypographyProps={esRaiz ? {} : { fontSize: 14 }}
          sx={{
            opacity: menuAncho ? 1 : 0,
            display: menuAncho ? "block" : "none",
            whiteSpace: "nowrap"
          }}
        />
        {menuAncho && (
          <IconButton
            size="small"
            aria-label={desplegado ? "ocultar " + item.title : "mostrar " + item.title}
            onClick={(event) => {
              event.stopPropagation();
              toggleGrupo(clave, menuAncho, abrirMenu);
            }}
          >
            {desplegado ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}
      </ListItemButton>
      <Collapse in={desplegado && menuAncho} timeout="auto" unmountOnExit>
        <List disablePadding>
          {item.children.map((hijo) => (
            <ItemMenu
              key={hijo.title}
              item={hijo}
              rama={rama.concat(hijo.title)}
              menuAncho={menuAncho}
              gruposAbiertos={gruposAbiertos}
              toggleGrupo={toggleGrupo}
              rutaActual={rutaActual}
              onNavegar={onNavegar}
              abrirMenu={abrirMenu}
            />
          ))}
        </List>
      </Collapse>
    </ListItem>
  );
}

function Layout() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const drawerVisible = isDesktop || open;
  const drawerExpanded = isDesktop && open;
  // El panel del menu muestra los titulos cuando esta abierto: en escritorio,
  // cuando el menu esta desplegado; en movil, cuando se abre con el boton.
  const menuAncho = drawerVisible && open;

  const navigate = useNavigate();
  const usuario = obtenerUsuario();

  // Accesos del usuario: acotan que opciones del menu se ven. Con la
  // seguridad desactivada, o sin accesos cargados, se concede todo.
  const dispatch = useDispatch();
  const accesos = useSelector((state) => state.seguridad?.accesos) || [];
  const roles = useSelector((state) => state.seguridad?.roles) || [];
  const seguridadActiva = useSelector((state) => state.seguridad?.seguridadActiva) || "N";

  React.useEffect(() => {
    seguridadService.getsParametros()
      .then((parametros) => dispatch(setParametros(parametros)))
      .catch((err) => { console.log("Err: ", err) });

    if (!usuario) return;

    seguridadService.getsPerfil()
      .then((perfil) => dispatch(setPerfil(perfil)))
      .catch((err) => { console.log("Err: ", err); });

    seguridadService.getsAccesosUsuario(usuario)
      .then((lista) => dispatch(setAccesos(lista || [])))
      .catch((err) => { console.log("Err: ", err); });
  }, [usuario, dispatch]);

  // Las opciones visibles del menu. El filtro por accesos vive en menu.js
  // porque tambien lo usa el inicio.
  const navGroupsVisibles = visiblesDe(navGroups, accesos, seguridadActiva, usuario, roles);

  const salir = () => {
    cerrarSesion();
    dispatch(limpiarSeguridad());
    window.location.replace("/login");
  };

  React.useEffect(() => {
    if (!isDesktop) {
      abiertoRef.current = false;
      setOpen(false);
    }
  }, [isDesktop]);

  // Al pulsar cualquier opcion del menu el menu se oculta: en escritorio se
  // repliega a la barra de iconos y en movil se cierra el menu desplegado.
  // Antes de cerrarlo se guarda el desplazamiento: al volver a abrirlo no
  // debe aparecer otra vez en la parte de arriba.
  const handleMenuItemClick = () => {
    cerrarMenu();
  };

  const handleDrawerOpen = () => {
    abiertoRef.current = true;
    setOpen(true);
  };

  const handleDrawerClose = () => {
    cerrarMenu();
  };

  // El grupo de la pantalla abierta queda desplegado, para no perder de vista
  // en que parte del menu se esta trabajando.
  //
  // Con subgrupos la opcion puede colgar de un subgrupo, no del grupo: se
  // busca en todos los niveles y se devuelven todas las claves de la rama,
  // que son las que hay que ir abriendo.
  const location = useLocation();

  const clavesDeRuta = (pathname) => {
    const esLaRuta = (item) => pathname === item.path
      || pathname.indexOf(item.path + "/") === 0;

    // Busca dentro de un item y devuelve la rama de claves hasta la opcion.
    const buscar = (item, rama) => {
      if (item.path && esLaRuta(item)) return rama;

      for (const hijo of item.children || []) {
        const encontrada = buscar(hijo, rama.concat(hijo.title));

        if (encontrada) return encontrada;
      }

      return null;
    };

    for (const grupo of navGroups) {
      const encontrada = buscar(grupo, [grupo.title]);

      if (encontrada) return encontrada;
    }

    return null;
  }

  const [gruposAbiertos, setGruposAbiertos] = React.useState({});

  // Contenedor del menu desplegable. Sirve para saber si el puntero
  // o el enfoque estan todavia dentro del menu.
  const menuRef = React.useRef(null);
  // Abierto de verdad, no el estado de React: al cerrar el papel pierde el
  // scroll y un listener tarde lo pisaria con 0.
  const abiertoRef = React.useRef(false);
  const scrollMenuRef = React.useRef(0);

  const papelMenu = () => (menuRef.current ? menuRef.current.querySelector(".MuiDrawer-paper") : null);

  const recordarScroll = () => {
    const papel = papelMenu();
    if (!papel || !abiertoRef.current) return;
    scrollMenuRef.current = papel.scrollTop;
  };

  const cerrarMenu = () => {
    recordarScroll();
    abiertoRef.current = false;
    const activo = document.activeElement;
    if (activo && menuRef.current && menuRef.current.contains(activo)) activo.blur();
    setOpen(false);
  };

  // Solo la rama hasta esta clave. Abrir un grupo cierra los demas: acordeon.
  const soloRama = (clave) => {
    const partes = clave.split(" > ");
    const abiertos = {};
    partes.forEach((_, indice) => {
      abiertos[partes.slice(0, indice + 1).join(" > ")] = true;
    });
    return abiertos;
  };

  React.useEffect(() => {
    const claves = clavesDeRuta(location.pathname);
    if (!claves) return;

    // La pantalla abierta deja solo su rama desplegada. No se suman los
    // grupos que se habian abierto antes.
    const abiertos = {};
    claves.forEach((_, indice) => {
      abiertos[claves.slice(0, indice + 1).join(" > ")] = true;
    });
    setGruposAbiertos(abiertos);
  }, [location.pathname]);

  // El menu desplegado se oculta al pulsar fuera de el.
  //
  // El cierre se hace despues de que el clic se haya entregado, no durante: si se
  // cierra en el mousedown, el control de la derecha se redibuja antes de recibir
  // el click y lo pierde. Por eso se aplaza al siguiente fotograma.
  //
  // Se registra solo el mousedown. El enfoque no se escucha a proposito: al pulsar
  // un campo de texto el navegador le da el foco en ese mismo mousedown, y cerrar
  // el menu por ahi le roba el foco al campo.
  const ultimoClicRef = React.useRef(null);
  const abiertoEnRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;

    let pendiente = null;

    const alPulsar = (evento) => {
      ultimoClicRef.current = { x: evento.clientX, y: evento.clientY };

      // El boton que alterna el menu no cuenta como "fuera de el": es el control
      // del propio menu.
      if (
        evento.target &&
        evento.target.closest &&
        evento.target.closest('[aria-label="Alternar menu"]')
      ) {
        return;
      }

      if (menuRef.current && menuRef.current.contains(evento.target)) return;

      // Clic en el mismo punto del que abrio el menu: es el del propio toggle, no
      // uno externo. Sin esta comprobacion el clic que despliega se contaria como
      // clic fuera y el menu se cerraria de inmediato.
      if (
        abiertoEnRef.current &&
        evento.clientX === abiertoEnRef.current.x &&
        evento.clientY === abiertoEnRef.current.y
      ) {
        return;
      }

      // Se aplaza el cierre para que el clic llegue a su destino.
      if (pendiente) window.clearTimeout(pendiente);

      pendiente = window.setTimeout(() => {
        pendiente = null;
        cerrarMenu();
      }, 0);
    };

    document.addEventListener("mousedown", alPulsar, true);

    return () => {
      document.removeEventListener("mousedown", alPulsar, true);

      if (pendiente) window.clearTimeout(pendiente);
    };
  }, [open]);

  // Al desplegar el menu se guarda el punto del clic que lo abrio.
  const toggleMenu = () => {
    if (!open) {
      abiertoEnRef.current = ultimoClicRef.current;
      abiertoRef.current = true;
      setOpen(true);
      return;
    }

    cerrarMenu();
  };

  // Al volver a abrir, el papel arranca en 0. Se lleva a la vista la opcion
  // de la pantalla actual, no el inicio del listado.
  React.useEffect(() => {
    if (!open) return;

    abiertoRef.current = true;

    const mostrar = () => {
      const papel = papelMenu();
      if (!papel) return;

      const ruta = location.pathname;
      const items = papel.querySelectorAll("[data-menu-ruta]");
      let destino = null;
      let largo = -1;

      items.forEach((el) => {
        const path = el.getAttribute("data-menu-ruta") || "";
        const coincide = ruta === path || (path.length > 1 && ruta.indexOf(path + "/") === 0);
        if (coincide && path.length > largo) {
          destino = el;
          largo = path.length;
        }
      });

      if (!destino) destino = papel.querySelector('[data-menu-abierto="1"]');
      if (!destino) {
        papel.scrollTop = scrollMenuRef.current;
        return;
      }

      const papelRect = papel.getBoundingClientRect();
      const elemRect = destino.getBoundingClientRect();
      const margen = 12;
      if (elemRect.top < papelRect.top + margen) {
        papel.scrollTop -= (papelRect.top + margen) - elemRect.top;
      } else if (elemRect.bottom > papelRect.bottom - margen) {
        papel.scrollTop += elemRect.bottom - (papelRect.bottom - margen);
      }
    };

    let vivo = true;
    const aplicar = () => { if (vivo) mostrar(); };
    const marco = window.requestAnimationFrame(() => {
      aplicar();
      window.requestAnimationFrame(aplicar);
    });
    const tarde = window.setTimeout(aplicar, 280);

    const papel = papelMenu();
    const alDesplazar = () => {
      if (!abiertoRef.current || !papel) return;
      scrollMenuRef.current = papel.scrollTop;
    };
    if (papel) papel.addEventListener("scroll", alDesplazar, { passive: true });

    return () => {
      vivo = false;
      window.cancelAnimationFrame(marco);
      window.clearTimeout(tarde);
      if (papel) papel.removeEventListener("scroll", alDesplazar);
    };
  }, [open, location.pathname]);

  // toggleGrupo recibe el ancho del menu y el que abre el menu porque lo
  // invoca ItemMenu, que vive fuera de Layout y no los tiene por cierre.
  // Abrir un grupo cierra el que estaba abierto. Un subgrupo mantiene a su
  // padre; el resto de la rama anterior se repliega.
  const toggleGrupo = (clave, ancho, abrir) => {
    if (!ancho) {
      abiertoRef.current = true;
      (abrir || setOpen)(true);
      setGruposAbiertos(soloRama(clave));
      return;
    }

    setGruposAbiertos((previos) => {
      if (previos[clave]) {
        const siguiente = { ...previos };
        Object.keys(siguiente).forEach((k) => {
          if (k === clave || k.indexOf(clave + " > ") === 0) delete siguiente[k];
        });
        return siguiente;
      }

      return soloRama(clave);
    });
  }


  return (
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar position="fixed">
            <Toolbar>
              <IconButton
                color="inherit"
                edge="start"
                aria-label="Alternar menu"
                onClick={toggleMenu}
                sx={{ marginRight: 1 }}
              >
                {drawerExpanded ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton>
              {/* <IconButton
                color="inherit"
                edge="start"
                onClick={() => {
                  if (open) {
                    handleDrawerClose();
                  } else {
                    handleDrawerOpen();
                  }
                }}
                sx={{ marginRight: 5 }}
              >
                {open ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton> */}
              {/* <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerOpen}
                sx={{
                  marginRight: 5,
                  ...(open && { display: 'none' }),
                }}
              >
                <MenuIcon />
              </IconButton> */}
              {/* Titulo con el logo. El alto del logo y el del texto se ajustan al ancho de
                  la ventana con clamp(): crecen en pantallas anchas y se
                  reducen en las angostas, sin necesidad de puntos de quiebre.
                  En movil angosto queda solo el logo, que ya identifica el
                  sistema.

                  El logo ya trae el nombre de la institucion, asi que al lado
                  solo va el nombre del sistema. */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 0.5, sm: 1 },
                  minWidth: 0,
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/logosinletras.png"}
                  alt="KOLOB Autismo Peru"
                  style={{
                    height: "clamp(26px, 3.6vw, 40px)",
                    width: "auto",
                    display: "block",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "inherit",
                    fontSize: "clamp(0.95rem, 2.1vw, 1.5rem)",
                    lineHeight: 1.15,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  Sistema Terapeutico
                </Typography>
              </Box>
              {usuario && <PerfilUsuario usuario={usuario} />}
              <Tooltip title="Cerrar sesiÃƒÂ³n">
                <IconButton color="inherit" onClick={salir} aria-label="Cerrar sesiÃƒÂ³n">
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>
          {drawerVisible && (
            // El cierre por clic fuera lo lleva el listener de mousedown de mas
            // arriba, que distingue el clic que abrio el menu de los externos. Por
            // eso aca no se usa ClickAwayListener: responderia tambien al clic que
            // abre el menu y lo cerraria de inmediato.
            <Box ref={menuRef}>
          <Drawer
            variant="permanent"
            expanded={menuAncho}
            sx={{ display: { xs: open ? "block" : "none", md: "block" } }}
          >
            <DrawerHeader>
              <IconButton
                color="inherit"
                edge="start"
                onClick={toggleMenu}
                sx={{ marginRight: 5 }}
              >
                {open ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton>
            </DrawerHeader>
            <Divider />
              <List>
                {navGroupsVisibles.map((grupo) => (
                  <ItemMenu
                    key={grupo.title}
                    item={grupo}
                    rama={[grupo.title]}
                    menuAncho={menuAncho}
                    gruposAbiertos={gruposAbiertos}
                    toggleGrupo={toggleGrupo}
                    rutaActual={location.pathname}
                    onNavegar={handleMenuItemClick}
                    abrirMenu={handleDrawerOpen}
                  />
                ))}
              </List>
            <Divider />
          </Drawer>
          </Box>
          )}
          {/* El margen del contenido es siempre el del menu reducido: al desplegarse,
            el menu se superpone y no empuja los controles de la derecha. Asi el
            clic sobre ellos no se pierde por un corrimiento del layout. */}
          <Box component="main" sx={{ flexGrow: 1, paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            ml: {
              xs: 0,
              md: `${drawerClosedWidth}px`,
            },
          }}>
          {/* <Box component="main" sx={{ flexGrow: 1, paddingTop: 2, paddingLeft: 0, paddingRight: 0 }}> */}
            <DrawerHeader />
            <Container sx={{ pb: 8 }}>
              <RutaConAcceso>
              <Routes>
                <Route path="/contactanos"></Route>
                <Route path="/person" element={<Person />} ></Route>
                <Route path="/person/edit/:id/:idPersona/:idTipoPersona" element={<PersonEdit />}></Route>
                <Route path="/person/editLegal/:id" element={<PersonEditLegal />}></Route>
                <Route path="/model" element={<Model />} ></Route>
                <Route path="/member" element={<Member />} ></Route>
                <Route path="/member/edit/:id" element={<MemberEdit />}></Route>
                <Route path="/therapy" element={<Therapy />} ></Route>
                <Route path="/therapy/edit/:id" element={<TherapyEdit />} ></Route>
                <Route path="/therapyplan" element={<TherapyPlan />} ></Route>
                <Route path="/therapyplanterapist" element={<TherapyPlanTherapist />} ></Route>
                <Route path="/therapyplanterapist/edit/:id" element={<TherapyPlanTherapistEdit />} ></Route>
                <Route path="/therapyplanterapist/edit/:id/:idTerapia" element={<TherapyPlanTherapistEdit />} ></Route>
                <Route path="/therapyplan/edit/:id" element={<TherapyPlanEdit />} ></Route>
                <Route path="/therapyplan/edit/:id/:idTerapia" element={<TherapyPlanEdit />} ></Route>
                <Route path="/period" element={<Period />} ></Route>
                <Route path="/period/edit/:id" element={<PeriodEdit />} ></Route>
                <Route path="/filial" element={<Filial />} ></Route>
                <Route path="/salon" element={<SalonIndex />} ></Route>
                <Route path="/direccion" element={<DireccionIndex />} ></Route>
                <Route path="/ubigeo" element={<UbigeoIndex />} ></Route>
                <Route path="/filial/edit/:id" element={<FilialEdit />} ></Route>
                <Route path="/puntuacion" element={<Puntuacion />} ></Route>
                <Route path="/puntuacion/edit/:id" element={<PuntuacionEdit />} ></Route>
                <Route path="/configuracion" element={<Configuracion />} ></Route>
                <Route path="/configuracion/edit/:id" element={<ConfiguracionEdit />} ></Route>
                <Route path="/bitacora" element={<Bitacora />} ></Route>
                <Route path="/bitacora/operaciones" element={<OperacionesBitacora />} ></Route>
                <Route path="/seguridad/bitacora-reportes" element={<BitacoraReportes />} ></Route>
                <Route path="/bitacora/reportes" element={<BitacoraReportes />} ></Route>
                <Route path="/monitoreo" element={<Monitoreo />} ></Route>
                <Route path="/evaluacion/:idParticipante" element={<Evaluacion />} ></Route>
                <Route path="/evaluacion/edit/:id/:idParticipante" element={<EvaluacionEdit />} ></Route>
                <Route path="/evaluacion/temas" element={<EvaluacionTema />} ></Route>
                <Route path="/evaluacion/temas/edit/:id" element={<EvaluacionTemaEdit />} ></Route>
                <Route path="/objetivocatalogo" element={<ObjetivoCatalogo />} ></Route>
                <Route path="/objetivocatalogo/edit/:id" element={<ObjetivoCatalogoEdit />} ></Route>
                <Route path="/participanteobjetivo" element={<ParticipanteObjetivo />} ></Route>
                <Route path="/participanteobjetivo/edit/:id/:idParticipante" element={<ParticipanteObjetivoEdit />} ></Route>
                <Route path="/diaferiado" element={<DiaFeriado />} ></Route>
                <Route path="/atencion" element={<Atencion />} ></Route>
                <Route path="/atencion/edit/:id" element={<AtencionEdit />} ></Route>
                <Route path="/diagnostico" element={<Diagnostico />} ></Route>
                <Route path="/diagnostico/edit/:idAtencion/:numero" element={<DiagnosticoEdit />} ></Route>
                <Route path="/horario-terapeuta" element={<HorarioTerapeuta />} ></Route>
                <Route path="/therapyPeriod" element={<TherapyPeriod />} ></Route>
                <Route path="/therapyPeriod/open" element={<TherapyPeriodOpen />} ></Route>
                <Route path="/therapyperiod/pago" element={<TherapyPeriodPayment />} ></Route>
                <Route path="/therapyperiod/pago/edit/:id/:numero" element={<TherapyPeriodPaymentEdit />} ></Route>
<Route path="/therapyperiod/descuentos" element={<TherapyPeriodDescuentos />} ></Route>
                <Route path="/security/user" element={<SecurityUser />} ></Route>
                <Route path="/security/user/edit/:id" element={<SecurityUserEdit />} ></Route>
                <Route path="/security/role" element={<SecurityRole />} ></Route>
                <Route path="/security/role/edit/:id" element={<SecurityRoleEdit />} ></Route>
                <Route path="/security/access" element={<SecurityAccess />} ></Route>
                <Route path="/authorization" element={<Authorization />} ></Route>
                <Route path="/session" element={<Session />} ></Route>
                <Route path="/session/:id" element={<SessionTherapist />} ></Route>
                <Route path="/session/edit/:id/:idTerapiaPeriodo" element={<SessionEdit />} ></Route>
                <Route path="/sesionterapeuta" element={<SesionTerapeuta />} ></Route>
                <Route path="/planilla" element={<Planilla />} ></Route>
                <Route path="/reporte" element={<ReporteIndex />} ></Route>
                <Route path="/reporte/modelo" element={<ReporteModelo />} ></Route>
                <Route path="/reporte/terapia" element={<ReporteTerapia />} ></Route>
                <Route path="/reporte/sesion" element={<ReporteSesion />} ></Route>
                <Route path="/reporte/planterapia" element={<ReportePlanTerapia />} ></Route>
                <Route path="/reporte/trimestral" element={<ReporteTrimestral />} ></Route>
                <Route path="/reporte/ficha-participante" element={<ReporteFichaParticipante />} ></Route>
                <Route path="/reporte/curva-eficacia" element={<ReporteCurvaEficacia />} ></Route>
                <Route path="/inventario/articulos" element={<ArticuloIndex />} ></Route>
                <Route path="/inventario/kardex" element={<KardexIndex />} ></Route>
                <Route path="/inventario/reportes" element={<ReporteKardex />} ></Route>
                <Route path="/cajachica" element={<CajaChicaIndex />} ></Route>
                <Route path="/cajachica/reportes" element={<ReporteCajaChica />} ></Route>
                <Route path="/invoiceItem" element={<InvoiceItem />} ></Route>
                <Route path="/invoiceItem/edit/:id" element={<InvoiceItemEdit />} ></Route>
<Route path="/descuentocatalogo" element={<DescuentoCatalogo />} ></Route>
<Route path="/descuentocatalogo/edit/:id" element={<DescuentoCatalogoEdit />} ></Route>
                <Route path="/receipt" element={<Receipt />} ></Route>
                <Route path="/receipt/edit/:id" element={<ReceiptEdit />} ></Route>
                <Route path="/receipt/pago" element={<ReceiptPayment />} ></Route>
                <Route path="/receipt/pago/:id" element={<ReceiptPayment />} ></Route>
                <Route path="/receipt/pago/anular" element={<ReceiptAnularPago />} ></Route>
                <Route path="/receipt/pago/consolidar" element={<ReceiptConsolidarPagos />} ></Route>
                <Route path="/receipt/print/:id" element={<ReceiptPrint />} ></Route>
                <Route path="/catalog" element={<Catalog />} ></Route>
                <Route path="/catalog/edit/:id" element={<CatalogEdit />} ></Route>
                <Route path="/trabajador" element={<Trabajador />} ></Route>
                <Route path="/trabajador/edit/:id" element={<TrabajadorEdit />} ></Route>
                <Route path="/cargo" element={<Cargo />} ></Route>
                <Route path="/cargo/edit/:id" element={<CargoEdit />} ></Route>
                <Route path="/grupocargo" element={<GrupoCargo />} ></Route>
                <Route path="/grupocargo/edit/:id" element={<GrupoCargoEdit />} ></Route>
                <Route path="/nosotros"></Route>
                <Route path="/" element={<Dashboard />}></Route>
              </Routes>
              </RutaConAcceso>
            </Container>
          </Box>
        </Box>
  );
}

function App() {
  const [openMessage, setOpenMessage] = React.useState(false);
  const [propsMessage, setPropsMessage] = React.useState({
      severity: "info",
      message: ""
  });

  const onCloseMessage = () => {
    setOpenMessage(false);
  };

  React.useEffect(() => {
    registerShowMessage((messageData) => {
        setPropsMessage(messageData);
        setOpenMessage(true);
    });
  }, []);

  return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<RutaProtegida><Layout /></RutaProtegida>} />
        </Routes>
        <Snackbar
            open={openMessage}
            autoHideDuration={5000}
            onClose={onCloseMessage}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center"
            }}
        >
            <Alert
                onClose={onCloseMessage}
                severity={propsMessage.severity}
            >
                {propsMessage.message}
            </Alert>
        </Snackbar>
      </Router>
  );
}

export default App;
